import { Component, OnInit, Output, EventEmitter, Input, Injector, ApplicationRef, ComponentFactoryResolver, ViewChild, ElementRef } from '@angular/core';
import { PopWindowConfig, VisibleChangeEvent, PopWindow } from '../popwindow/popwindow.component';
import { NzDrawerComponent } from 'ng-zorro-antd';
declare var $;
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.css']
})
export class DrawerComponent implements OnInit {

  public bodyStyle = {
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    padding: '0px'
  }

  private _windowConifg: PopWindowConfig = {
    title: "",
    width: 800,
    height: 600,
    theme: 'theme-white',
    contentComponent: null,  //显示到弹窗上的组件
  }
  @Output() visibleChanged = new EventEmitter<VisibleChangeEvent>();
  //窗口配置
  @Input()
  set windowConfig(config: PopWindowConfig) {
    $.extend(this._windowConifg, config);
  }
  get windowConfig(): PopWindowConfig {
    return this._windowConifg;
  }

  constructor(private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
  }

  @ViewChild('nzContent', { static: false })
  nzContent: ElementRef;
  //创建子组件
  private createChildComponent(params: any) {
    const that = this;
    var factory = this.componentFactoryResolver.resolveComponentFactory(this.windowConfig.contentComponent);
    var popupComponentRef = factory.create(this.injector, [], this.nzContent.nativeElement);
    var popwindow: PopWindow = popupComponentRef.instance as PopWindow;
    popwindow.pageParams = params;
    popwindow.closePopwindow = function (reason = null) {
      that.setVisible(false, null, reason);
    }
    popupComponentRef.instance["pageParams"] = params;
    this.applicationRef.attachView(popupComponentRef.hostView);
  }

  //窗口显示和隐藏
  public drawerVisible = false;
  //设置状态显示
  public setVisible(visible: boolean, params: any = null, changereson = null) {
    if (visible) {
      this.createChildComponent(params);
      this.drawerVisible = true;
    } else {
      this.drawerVisible = false;
    }
    this.visibleChanged.emit({
      visible: visible,
      reason: changereson
    });
  }
}
